<main>
    <div class="row register" [ngClass]="{'fly-out': registerService._isFlyout}">
        <div class="col center">
            <h1>Thank you for joining, <span class="block bold">you’re almost done!</span></h1>
            <p class="mt70 mb40">
                Next, we'll send you an activation code to confirm your details.
            </p>
            <div class="type-select activation">
                <h3>How do you want to receive your code?</h3>
                <div class="row">
                    <div class="col type" [ngClass]="{'selected': !model.actiByEmail}" style="height: 75px;">
                        <input type="radio" [(ngModel)]='model.actiByEmail' name="activation-code" id="activiation-phone" [value]="false" checked="!model.actiByEmail">
                        <label for="activiation-phone">Cell / Mobile Number</label>
                    </div>
                    <div class="col type " [ngClass]="{'selected': model.actiByEmail}" style="height: 75px;">
                        <input type="radio" [(ngModel)]='model.actiByEmail' name="activation-code" id="activiation-email" [value]="true" checked="model.actiByEmail">
                        <label for="activiation-email">Email Address</label>
                    </div>
                </div>
            </div>
            <div class="field" *ngIf="!model.actiByEmail">
                <input type="tel" [(ngModel)]='model.phone' id="register-activate-phone" placeholder="Cell / Mobile Number" value="01234 567890">
                <label for="register-activate-phone">Cell / Mobile Number</label>
                <button (click)="sendSmsCode()" [disabled]="isProcessStart">Send</button>
            </div>
            <div class="field" *ngIf="model.actiByEmail">
                <input type="email" [hidden]="isClaim" [(ngModel)]='model.email' id="register-activate-email" placeholder="Email Address">
                <input type="email" [hidden]="!isClaim" value="[Hidden for your protection]" disabled id="register-activate-email" placeholder="[Hidden for your protection]">
                <label for="register-activate-phone">Email Address</label>
                <button (click)="sendEmailCode()" [disabled]="isProcessStart">Send</button>
            </div>
            <p class="mt40 mb40">
                Enter the 6 digit code below to activate your account.
            </p>
            <div class="row activation-code">
                <div class="field">
                    <input [(ngModel)]='model.actiCode' id="register-activate-code" placeholder="Activation Code">
                    <label for="register-activate-code">Activation Code</label>
                </div>
                <button *ngIf="aauthService.regModel2.memberType != 1" class="btn primary" (click)="onSubmit()" [disabled]="isProcessStart">Activate profile</button>
                <button *ngIf="aauthService.regModel2.memberType == 1" class="btn primary" (click)="onSubmitMember()" [disabled]="isProcessStart">Activate membership</button>
            </div>
            <p class="mb40">
                <strong style="font-weight: 700">Didn't receive your activation code? Please check your spam folder or <a (click)="onSendActiveCode()">have it resent</a></strong>
            </p>
        </div>
        <a onclick="parent.callbackParent();" style="display:none;" id="btnCallback" href="javascript:void(0);"></a>
    </div>
</main>
